module.exports = __webpack_public_path__ + "static/media/arrow_left_desktop.59d30a79.svg";